import React from 'react';
import VideoCategoriesState from './videoCategoriesState/VideoCategoriesState';
import VideoCategoriesControlPanel from './components/VideoCategoriesControlPanel/VideoCategoriesControlPanel';
import VideoCategories from './components/VideoCategories/VideoCategories';
import ModalWindows from './components/ModalWindows/ModalWindows';
import style from './index.module.scss';

const VideoCategoriesPage: React.FC = () => {
	return (
		<VideoCategoriesState>
			<div className={style.container} data-test="VideoCategoriesPage">
				<VideoCategoriesControlPanel />
				<VideoCategories />
				<ModalWindows />
			</div>
		</VideoCategoriesState>
	);
};

export default VideoCategoriesPage;
